module.exports = "<app-level-price-list></app-level-price-list>\r\n"